import { post, get } from '../../../../services/request';

//-------------------Exam Data Dropdown Options - start----------------//
// Get exam data dropdown options
export const getExamDropdownOptions = (payload) => {
    return post(`ExamData/GetExamDataAllDDList`, payload);
};
//-------------------Exam Data Dropdown Options - end----------------//

// Get Recalculate Data
export const getRecalculateData = () => {
    return get(`ExamData/GetReCalculateRecordData`);
};

// Exam data record date
export const updateExamDataRecordDate = (payload) => {
    return post(`ExamData/GetExamDataRecordDate`, payload)
};

// Get all exam data
export const getAllExamData = (payload) => {
    return post(`ExamData/GetAllExamDataWithPagination`, payload);
};

//refresh raw exam data
export const refreshRawExamData = (payload) => {
    // Accepts a single object: { fromDate, toDate, userId }
    const { fromDate, toDate, userId } = payload || {};

    if (!fromDate || !toDate) throw new Error('fromDate and toDate are required for refreshRawExamData');
    return post(`ExamData/ReCalculateExamDataDetailsByDate?FromDate=${fromDate}&ToDate=${toDate}&CreatedBy=${userId}`);
};

// Get exam data from batch
export const getBatchRecordExamData = (ID) => {
    return get(`ExamData/GetExamDataDetailsByExamID?ExamDataID=${ID}`);
};

//Get batch by record date
export const getExamDataBatchByRecordDate = (recordDate) => {
    return get(`ExamData/GetExamDataBatchByRecordDate?recordDate=${recordDate}`);
}

// Save Batch Record

export const saveBatchRecord = (payload) => {
    return post(`ExamData/UpdateIsExcluded`, payload);
}

// Check Recalculation
export const checkRecalculation = () => {
    return get(`ExamData/CheckRecalculations`);
};

// Re Calculate Exam Data Details
export const reCalculateExamDataDetails = (payload) => {
    return post(`ExamData/ReCalculateExamDataDetails`, payload);
};

//-------------------Exam Data - end----------------//